var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.macros && Object.keys(_vm.macros).length > 0)?_c('div',[(_vm.macros.KCAL)?_c('div',{staticClass:"p-text navy--text"},[_vm._v("~"+_vm._s(_vm.macros.KCAL)+" kcal per serving")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }